import { createContext, useContext } from 'react';

export const UserAllocationsSummaryContext = createContext();

export const useUserAllocationsSummaryContext = () =>
  useContext(UserAllocationsSummaryContext);

export default UserAllocationsSummaryContext;
